<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $t('view') }} {{ $t('emailtemplate') }}</div>
      <div>
        <router-link
          to
          @click.native="goToRoute('/master/edit-email-template')"
          class="btn-blue"
        >{{ $t('edit') }}</router-link>
        <router-link
          class="btn-blue"
          to="email-template"
        >{{ $t('emailtemplate') }} {{ $tc('list', 1) }}</router-link>
      </div>
    </div>

    <div class="all-details-container">
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('emailtemplate') }} {{ $t('name') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-10">
            <span class="mr-3"></span>
            <span class="mr-3">{{ email_temp_name }}</span>
          </div>
        </div>
      </div>

      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('email') }} {{ $t('title') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-10">
            <span class="mr-3"></span>
            <span class="mr-3">{{ email_title }}</span>
          </div>
        </div>
      </div>

      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('email') }} {{ $t('content') }}</div>
          <span class="mr-3"></span>
          <div class="ml-3" v-html="content"></div>
        </div>
      </div>

      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">{{ $tc('status', 1)}}</div>
          <div class="col-md-9 col-lg-10 col-xl-10">
            <span class="mr-3"></span>
            <span v-if="email_temp_is_active == 'Y'" class="mr-3">Active</span>
            <span v-else class="mr-3">Inactive</span>
          </div>
        </div>
      </div>

      <div v-if="login_user_role_id === 1" class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('createdat') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3"></span>
            <span class="mr-3">{{ created_at | dateparse }}</span>
          </div>
        </div>
      </div>
      <div v-if="login_user_role_id === 1" class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('createdby') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3"></span>
            <span class="mr-3">{{ userDetails.created_by }}</span>
          </div>
        </div>
      </div>
      <div v-if="login_user_role_id === 1" class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('updatedat') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3"></span>
            <span class="mr-3">{{ updated_at | dateparse }}</span>
          </div>
        </div>
      </div>
      <div v-if="login_user_role_id === 1 " class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('updatedby') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3"></span>
            <span class="mr-3">{{ userDetails.updated_by }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import MasterService from "@/services/MasterService";
import CinemasService from "@/services/CinemasService";
import moment from "moment";

export default {
  data() {
    return {
      id: "",
      content: "",
      et_id: "",
      email_temp_name: "",
      email_title: "",
      email_temp_is_active: true,
      login_user_role_id: null,
      userDetails: [],
      created_at: "",
      updated_at: "",
    };
  },
  beforeMount() {
    const { et_id } = this.$route.query;
    this.id = et_id;
    const { role_id } = this.secureStore.get("USINFO");
    this.login_user_role_id = role_id;
    this.GetEmailTemplateByID(et_id);
  },

  methods: {
    goToRoute: function (path) {
      this.$router.push({
        path: path,
        query: { et_id: this.id },
      });
    },
    GetEmailTemplateByID: function (id) {
      let payload = { et_id: id };

      MasterService.GetSingleEmailTemplate(payload)
        .then((response) => {
          const { data } = response;

          if (data && data.status) {
            console.log('MasterService.GetSingleEmailTemplate: ', data);
            if (data.Records && data.Records.et_body) {
              let Obj = data.Records;
              this.email_temp_name = Obj.et_description;
              this.email_title = Obj.et_subject;
              this.email_temp_is_active = Obj.is_et_active;

              this.created_at = Obj.created_at;
              this.updated_at = Obj.updated_at;

              this.content = Obj.et_body;

              this.getViewUsersDetails(Obj.created_by, "created_by");
              this.getViewUsersDetails(Obj.updated_by, "updated_by");
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    getViewUsersDetails(user_id, key) {
      if (user_id) {
        MasterService.GetUserInfoById({ user_id })
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.userDetails[key] = data.Records[0].user_name;
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      }
    },
  },
};
</script>


<style scoped>
.bl-5 {
  border-left: 3px solid #000000;
}
</style>






// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/EmailTemplateComponents/viewemailtemplate.vue